<template>
   <div>
      <v-card v-if="level.dialogValues.dialogShow">

         <CardUpdatableHeader :row="row" :level="level"/>

         <v-form v-model="isFormValid">
            <v-card-text>
               <v-container>

                  <v-row v-if="!level.dialogValues.form_create" no-gutters>
                  <v-col cols="12" align="center">
                     <v-icon size="96px" v-if="row.is_root">mdi-home</v-icon>
                     <v-icon size="96px" v-else-if="row.is_ou">mdi-folder</v-icon>
                     <v-icon size="96px" v-else-if="row.is_user">mdi-account</v-icon>
                     <v-icon size="96px" v-else-if="row.is_group">mdi-account-multiple</v-icon>
                     <v-icon size="96px" v-else-if="row.is_contact">mdi-account-outline</v-icon>
                     <v-icon size="96px" v-else>mdi-home</v-icon>
                     <br/>
                     <p v-if="!row.is_root">({{ row.type }})</p>
                     <h3 class="headline mb-2">
                        {{ row.name }}
                     </h3>
                  </v-col>
                  </v-row>

                  <h5>{{ $t('subtitles.lde_properties') }}</h5>
                  <v-row no-gutters>
                  <v-col v-if="!level.dialogValues.form_create" cols="12">
                     <v-text-field v-model="row.code" disabled :label="$t('texts.lde_code')">
                     </v-text-field>
                  </v-col>
                  <v-col v-else-if="row.parent && !row.parent.is_root" cols="12">
                     <v-text-field v-model="row.code" readonly :label="$t('texts.lde_path_on_create')">
                     </v-text-field>
                  </v-col>
                  <v-col v-if="!level.dialogValues.form_create" cols="12">
                     <v-text-field v-model="row.distinguishedname" disabled :label="$t('texts.lde_distinguishedname')">
                     </v-text-field>
                  </v-col>
                  </v-row>

                  <v-row v-if="level.dialogValues.form_create">
                     <v-col cols="12">
                     <ddoSelect2 :callbacks="LDTcallbacks" ref="myLDTSelect" :options="LDToptions">
                        <template v-slot:selection="data">
                           <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                           >
                              <span v-text="data.item.ldt_name"></span>
                           </v-chip>
                        </template>
                        <template v-slot:item="data">
                           <v-list-item-content>
                              <v-list-item-title v-html="data.item.ldt_name"></v-list-item-title>
                              <v-list-item-subtitle v-html="data.item.ldt_code"></v-list-item-subtitle>
                           </v-list-item-content>
                        </template>
                     </ddoSelect2>
                  </v-col>
                  </v-row>

                  <v-row no-gutters>
                  <v-col v-if="(bools.is_user||bools.is_group||bools.is_contact||bools.is_ou) && level.dialogValues.form_create" cols="12">
                     <v-text-field v-model="row.name" 
                        outlined 
                        :disabled="level.dialogValues.form_disabled" 
                        :label="$t('texts.lde_cn')" 
                        :rules="level.dialogOptions.codeRules" 
                        required 
                        :hint="$t('hints.lde_cn')" 
                        persistent-hint
                        @change="change_sam_to_align_on_cn"
                     >
                     </v-text-field>
                  </v-col>
                  </v-row>

                  <v-row no-gutters v-if="bools.is_user && !level.dialogValues.form_create">
                     <h5>{{ $t('subtitles.lde_accountname') }}</h5>
                     <v-col cols="12">
                        <h6>{{ $t('subtitles.lde_userprincipalname') }}</h6>
                        <v-text-field
                           v-model="row.userprincipalname"
                           outlined 
                           :disabled="level.dialogValues.form_disabled" 
                           :rules="level.dialogOptions.emailRules"
                           required 
                           :label="$t('texts.lde_userprincipalname')"
                        >
                        </v-text-field>
                     </v-col>
                     <v-col v-if="bools.is_user" cols="12">
                        <h6>{{ $t('subtitles.lde_samaccountname') }}</h6>
                        <v-text-field
                           v-model="row.samaccountname"
                           :disabled="level.dialogValues.form_disabled" 
                           :rules="level.dialogOptions.codeRules" 
                           required
                        >
                           <template v-slot:prepend>
                              <span>{{ lde_domain }}</span>
                           </template>
                        </v-text-field>
                     </v-col>
                  </v-row>

                  <v-row no-gutters>
                  <v-col v-if="(bools.is_user||bools.is_contact||bools.is_group)&&!level.dialogValues.form_create" cols="12">
                     <v-text-field
                        v-model="row.mail"
                        outlined 
                        :disabled="level.dialogValues.form_disabled" 
                        :rules="level.dialogOptions.emailRules"
                        :label="$t('texts.lde_mail')"
                        :hint="$t('hints.lde_mail')" 
                     >
                     </v-text-field>
                  </v-col>
                  <v-col v-if="bools.is_user&&level.dialogValues.form_create" cols="12">
                     <v-text-field
                        v-model="row.mail"
                        outlined 
                        :disabled="level.dialogValues.form_disabled" 
                        :rules="level.dialogOptions.emailRules" 
                        :label="$t('texts.lde_mail_and_upn')"
                        :hint="$t('hints.lde_mail_and_upn')" 
                        @change="change_login_to_align_on_email"
                     >
                     </v-text-field>
                  </v-col>
                  </v-row>

                  <v-row v-if="bools.is_user && level.dialogValues.form_create">
                     <v-col sm="12">
                        <v-text-field
                           v-model="password1"
                           maxlength="40"
                           :append-icon="show_pwd1 ? 'mdi-eye' : 'mdi-eye-off'"
                           :type="show_pwd1 ? 'text' : 'password'"
                           @click:append="show_pwd1=!show_pwd1"
                           :label="$t('texts.change_password1')"
                           required
                           :hint="$t('hints.change_password1')"
                           persistent-hint
                           :rules="[passwordcomplexityRule(password1)]"
                           autocomplete="new-password" 
                        >
                           <template v-slot:message="{ message, key }">
                              <span v-html="$t('hints.change_password1')"></span>
                           </template>    

                        </v-text-field>

                        <v-text-field
                           v-model="password2"
                           maxlength="40"
                           :append-icon="show_pwd2 ? 'mdi-eye' : 'mdi-eye-off'"
                           :type="show_pwd2 ? 'text' : 'password'"
                           @click:append="show_pwd2=!show_pwd2"
                           :label="$t('texts.change_password2')"
                           required
                           :hint="$t('hints.change_password2')"
                           :rules="[passwordsmatchRule(),passwordcomplexityRule(password2)]" 
                        >
                           <template v-slot:message="{ message, key }">
                              <span v-html="$t('hints.change_password2')"></span>
                           </template>                     
                        </v-text-field>

                        <v-btn small class="primary" rounded @click="generate_password">{{ $t('buttons.generate_password') }}</v-btn>

                     </v-col>

                  </v-row>

                  <v-row no-gutters v-if="bools.is_user||bools.is_contact">
                  <v-col cols="12" sm="6">
                     <v-text-field v-model="row.givenname"
                        :disabled="level.dialogValues.form_disabled" 
                        :label="$t('texts.lde_givenname')" 
                        :hint="$t('hints.lde_givenname')"
                        :rules="level.dialogOptions.codeRules" 
                     >
                     </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                     <v-text-field v-model="row.sn" :disabled="level.dialogValues.form_disabled" :label="$t('texts.lde_sn')" :hint="$t('hints.lde_sn')"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                     <v-text-field v-model="row.displayname" required :disabled="level.dialogValues.form_disabled" :label="$t('texts.lde_displayname')" :hint="$t('hints.lde_displayname')"></v-text-field>
                  </v-col>
                  </v-row>

                  <v-row no-gutters v-if="bools.is_user">
                     <h5>{{ $t('subtitles.lde_useraccountcontrols') }}</h5>
                     <v-col cols="12">
                        <ddoSelect2
                           :disabled="level.dialogValues.form_disabled"
                           :callbacks="ACCOUNTCONTROLScallbacks"
                           ref="myACCOUNCONTROLSSelect"
                           :options="ACCOUNTCONTROLSoptions"
                        >
                           <template v-slot:selection="data">
                              <v-chip
                                 v-bind="data.attrs"
                                 :input-value="data.selected"
                                 close
                                 @click:close="$refs.myACCOUNCONTROLSSelect.remove(data.item)"
                              >
                                 <span v-text="data.item.name"></span>
                              </v-chip>
                           </template>
                           <template v-slot:item="data">
                              <v-list-item-content>
                                 <v-list-item-title v-html="data.item.name"></v-list-item-title>
                              </v-list-item-content>
                           </template>
                        </ddoSelect2>
                     </v-col>
                  </v-row>

                  <v-row no-gutters v-if="bools.is_user||bools.is_group||bools.is_contact">
                     <h5>{{ $t('subtitles.lde_member_of') }}</h5>
                     <v-col cols="12">
                        <ddoSelect2
                           :disabled="level.dialogValues.form_disabled"
                           :callbacks="GRPcallbacks"
                           ref="myGRPSelect"
                           :options="GRPoptions"
                           @itemsLoaded="groups_loaded"
                        >
                           <template v-slot:selection="data">
                              <v-chip
                                 v-bind="data.attrs"
                                 :input-value="data.selected"
                                 close
                                 @click:close="$refs.myGRPSelect.remove(data.item)"
                              >
                                 <span v-text="data.item.cn"></span>
                              </v-chip>
                           </template>
                           <template v-slot:item="data">
                              <v-list-item-content>
                                 <v-list-item-title v-html="data.item.cn"></v-list-item-title>
                                 <v-list-item-subtitle v-html="data.item._pk"></v-list-item-subtitle>
                              </v-list-item-content>
                           </template>
                        </ddoSelect2>
                     </v-col>
                  </v-row>
               </v-container>
               <small>*{{ $t('texts.requiredfield') }}</small>
            </v-card-text>
         </v-form>

         <CardUpdatableFooterOneUpdate :row="row" :level="level">
            <template v-slot:content="props">
               <div v-if="level.dialogValues.form_delete">
                  <p>Voulez-vous <strong>VRAIMENT</strong> supprimer cette entrée LDAP ?<br/><br/>
                  En cliquant sur "Confirmer", vous validez cette suppression,
                  En cliquant sur "Annuler", vous revenez sur la fiche.
                  </p>
               </div>
               <div v-if="level.dialogValues.form_update">
                  <p>Vous avez demandé :<br/><br/>
                  <template v-if="old_useraccountcontrols.length>0">
                     - la suppression des options de compte :<br/>
                        <ul>
                           <li v-for="uac in old_useraccountcontrols"><strong>{{uac.name}}</strong></li>
                        </ul>
                  </template>
                  <template v-if="new_useraccountcontrols.length>0">
                     - l'activation des options de compte :<br/>
                        <ul>
                           <li v-for="uac in new_useraccountcontrols"><strong>{{uac.name}}</strong></li>
                        </ul>
                  </template>
                  <template v-if="old_groups.length>0">
                     - la suppression du rattachement au(x) groupe(s) :<br/>
                        <ul>
                           <li v-for="group in old_groups"><strong>{{group.cn}}</strong></li>
                        </ul>
                  </template>
                  <template v-if="new_groups.length>0">
                     - le rattachement au(x) groupe(s) :<br/>
                        <ul>
                           <li v-for="group in new_groups"><strong>{{group.cn}}</strong></li>
                        </ul>
                  </template>
                  En cliquant sur "Confirmer", vous validez cette demande,
                  En cliquant sur "Annuler", vous revenez sur la fiche pour de nouvelles modifications.
                  </p>
               </div>
            </template>
         </CardUpdatableFooterOneUpdate>

      </v-card>
    </div>
</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooterConfirm from '@/components/partials/CardUpdatableFooterConfirm.vue';
import CardUpdatableFooterOneUpdate from '@/components/partials/CardUpdatableFooterOneUpdate.vue';
import ddoSelect from '@/components/ddoSelect.vue';
import ddoSelect2 from '@/components/ddoSelect2.vue';

export default {
   name: 'CardUpdatableLdapEntry',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooterConfirm,
      CardUpdatableFooterOneUpdate,
      ddoSelect,
      ddoSelect2,
   },

   props: {
   },

   data: function () {
      return {
         lde_domain: "SAAS\\",
         new_groups: [],
         old_groups: [],
         new_useraccountcontrols: [],
         old_useraccountcontrols: [],

         password1: '',
         password2: '',
         show_pwd1: false,
         show_pwd2: false,

         LDTcallbacks: {},
         LDToptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            rules: [],
            item_text: "ldt_name",
            item_value: "ldt_pk",
            item_disabled: "",
            hide_selected: true,
            label: i18n.t('texts.lde_select_ldt_create'),
         },
         GRPcallbacks: {},
         GRPoptions: {
            initial: [],
            selected: [],
            required: false,
            disabled: false,
            multiple: true,
            clearable: false,
            item_text: "cn",
            item_value: "_pk",
            item_disabled: "",
            hide_selected: false,
            return_object: true,
            label: i18n.t('texts.lde_groups'),
         },
         ACCOUNTCONTROLScallbacks: {},
         ACCOUNTCONTROLSoptions: {
            initial: [],
            selected: [],
            required: false,
            disabled: false,
            multiple: true,
            clearable: false,
            item_text: "name",
            item_value: "_pk",
            item_disabled: "",
            hide_selected: false,
            return_object: true,
            label: i18n.t('texts.lde_useraccountcontrols'),
         },
         boolFormValid: true,
         boolGroupsChanged: false,
         boolUACChanged: false,
         userprincipalnameChanged: false,
         groupsLoaded: false,
         groupsChanged: false,
         bools: { is_user:false, is_group: false, is_contact: false, is_ou: false, is_root: false },

         accountcontrolsLoaded: false,
         items_useraccountcontrols: [
            { _pk: 0x000002, name: i18n.t('texts.lde_ACCOUNTDISABLE') },       // 2
            //{ _pk: 0x000040, name: i18n.t('texts.lde_PASSWD_CANT_CHANGE') },   // 64
            { _pk: 0x010000, name: i18n.t('texts.lde_DONT_EXPIRE_PASSWORD') }  // 65536
         ],
      }
   },

   created() {
      //this.build_select_accountcontrols();
   },

   mounted() {
      this.LDTcallbacks.refresh_rows = this.build_select_ldt;
      this.LDTcallbacks.change       = this.change;
      this.GRPcallbacks.refresh_rows = this.build_select_grp;
      this.GRPcallbacks.remove       = this.remove_group;
      this.GRPcallbacks.change       = this.change_group;
      this.ACCOUNTCONTROLScallbacks.refresh_rows = this.build_select_accountcontrols;
      this.ACCOUNTCONTROLScallbacks.remove       = this.remove_useraccountcontrol;
      this.ACCOUNTCONTROLScallbacks.change       = this.change_useraccountcontrol;
      this.level.callbacks.check_skip_confirm = this.check_skip_confirm;

      if ( this.$refs.myGRPSelect ) {
         this.$refs.myGRPSelect.refresh_rows();
      }

      if ( this.$refs.myACCOUNCONTROLSSelect ) {
         this.$refs.myACCOUNCONTROLSSelect.refresh_rows();
      }

      this.LDToptions.rules = this.level.dialogOptions.codeRules;
      console.log('mounted, calls clear_selectLDT');
      this.clear_selectLDT();
   },

   watch: {
      row: 'loadOtherInformations',
   },

   computed: {

      isFormValid: {
         get: function() {
            console.log('isFormValid, get, value='+this.boolFormValid);
            return this.boolFormValid;
         },
         set: function(newValue) {
            console.log('isFormValid, set, newValue='+newValue);
            this.boolFormValid = newValue;

            if ( this.password1==this.password2) {
               this.row.password = this.password1;
               this.$emit('change_dialogValues',this.level.level,'disable_create',!newValue);
            }

            if ( this.level.dialogValues.form_create==true ) {
               this.$emit('change_dialogValues',this.level.level,'disable_create',!newValue);
            }
            if ( this.level.dialogValues.form_update==true ) {
               this.$emit('change_dialogValues',this.level.level,'disable_update',!newValue);
            }
         }
      },

      passwordcomplexityRule(password) {
         return v => this.$api._check_passwordcomplexity(v) || i18n.t('messages.password_not_complex');
      },

      passwordsmatchRule() {
         return v => this.password1==this.password2 || i18n.t('messages.passwords_not_equal');
      },

   },

   methods: {

      change_login_to_align_on_email(data) {
         this.row.userprincipalname = data;
         console.log('change_login_to_align_on_email, data='+data);
      },

      change_sam_to_align_on_cn(data) {
         if ( this.bools.is_user==true ) {
            this.row.samaccountname = data.substring(0,20);
            console.log('change_sam_to_align_on_cn, data='+data);
         }
      },

      clear_selectLDT() {
         this.LDToptions.initial = null;
         this.LDToptions.selected = null;
      },

      generate_password() {
         this.password1 = this.$api._generate_password(2);
         this.password2 = this.password1;
      },

      /*
       * We mark the fact that GRPselect is loaded/refreshed
       * ESSENTIAL for 'loadOtherInformations()', which references 'this.$refs.myGRPSelect'
       */ 
      groups_loaded(items) {
         this.groupsLoaded = true;
         if ( this.row ) {
            this.loadOtherInformations(this.row);
         }
      },

      /*
       * We build the 'initial' array of groups, by looking into 'row.memberof', an array
       *    which contains all 'dn' (i-e '_pk') of groups.
       * But, we do that, ONLY if 'GRPselect' has been refreshed at least ONCE.
       * The following function triggers each time 'this.row' changes.
       */ 
      loadOtherInformations(row,oldRow) {
         var result = [];
         if ( this.groupsLoaded && this.$refs.myGRPSelect && row.memberof ) {
            for ( var i=0;i<row.memberof.length;i++ ) {
               result.push( this.$api._get_by_pk(this.$refs.myGRPSelect.items,row.memberof[i]) );
            }
         }
         this.GRPoptions.initial = result;
         this.GRPoptions.selected = result;
         this.new_groups = [];
         this.old_groups = [];

         this.bools.is_ou      = row.is_ou;
         this.bools.is_group   = row.is_group;
         this.bools.is_user    = row.is_user;
         this.bools.is_contact = row.is_contact;
         this.bools.is_root    = false;

         this.ACCOUNTCONTROLSoptions.initial = [];
         this.ACCOUNTCONTROLSoptions.selected = [];
         this.build_initial_accountcontrols();
      },

      async refresh_select_ldt(key=null) {
         await this.$refs.myLDTSelect.refresh_rows(key);
      },

      async build_select_ldt(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'ldapentrytype');
         this.loading = false;
         return { errorinfos, api_response }
      },
      
      async build_select_grp(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'ldapconnector/'+this.level.childKey+'/groups');
         this.loading = false;
         return { errorinfos, api_response }
      },

      build_select_accountcontrols(key=null) {
         return { errorinfos: 0, api_response: { error: 0, rows: this.items_useraccountcontrols } }
      },

      remove_useraccountcontrol(item) {
         console.log('remove_useraccountcontrol, item='+JSON.stringify(item));
         if ( item._pk ) {
            /*
             * We remove it from 'new_groups', if it is in this array
             */
            this.$api._remove_by_pk(this.new_useraccountcontrols,item._pk);
            /*
             * We retrieve the _pk of the user to add in 'old_groups' array, and add it from 'old_groups'
             * But there is no need to do that if we are in creation mode
             */
            if ( this.level.dialogValues.form_create!=true ) {
               this.$api._remove_by_pk(this.old_useraccountcontrols,item._pk);
               this.old_useraccountcontrols.push(JSON.parse(JSON.stringify(item)));
            }
            // We remove it from the selection, but it could have deen done in parent 'remove' function
            this.$api._remove_by_pk(this.ACCOUNTCONTROLSoptions.selected,item._pk);
            this.boolUACChanged = true;
            this.recheck_elements();
         }
      },

      async change_useraccountcontrol(values,item=null) {
         console.log('change_useraccountcontrol, values='+JSON.stringify(values))
         console.log('change_useraccountcontrol, initial='+JSON.stringify(this.ACCOUNTCONTROLSoptions.initial))

         if ( this.ACCOUNTCONTROLSoptions.initial ) {

            for ( var i=0;i<values.length;i++ ) {
               // Take care : some row could be NULL (corresponding to unknown AD groups)
               if ( values[i]!=null ) {
                  var _pk0 = this.$api._get_by_pk(this.old_useraccountcontrols,values[i]._pk);
                  var _pk1 = this.$api._get_by_pk(this.new_useraccountcontrols,values[i]._pk);
                  var _pk2 = this.$api._get_by_pk(this.ACCOUNTCONTROLSoptions.initial,values[i]._pk);
                  console.log('change_group, values[i]='+JSON.stringify(values[i])+', PHASE 1, pk0='+JSON.stringify(_pk0)+', pk1='+JSON.stringify(_pk1)+', pk2='+JSON.stringify(_pk2))
                  if ( _pk0==null && _pk1==null && _pk2==null ) {
                     this.new_useraccountcontrols.push(values[i]);
                     this.boolUACChanged = true;
                  }
                  if ( _pk0!=null && _pk1==null && _pk2!=null ) {
                     this.$api._remove_by_pk( this.old_useraccountcontrols,_pk0._pk);
                     this.boolUACChanged = true;
                  }
               } 
            }
            console.log('change_useraccountcontrol, PHASE1, old_useraccountcontrols='+JSON.stringify(this.old_useraccountcontrols))
            console.log('change_useraccountcontrol, PHASE1, new_useraccountcontrols='+JSON.stringify(this.new_useraccountcontrols))

            for ( var i=0;i<this.ACCOUNTCONTROLSoptions.initial.length;i++ ) {
               // Take care : some row could be NULL (corresponding to unknown AD groups)
               if ( this.ACCOUNTCONTROLSoptions.initial[i]!=null ) {
                  var _pk0 = this.$api._get_by_pk(this.new_useraccountcontrols,this.ACCOUNTCONTROLSoptions.initial[i]._pk);
                  var _pk1 = this.$api._get_by_pk(this.old_useraccountcontrols,this.ACCOUNTCONTROLSoptions.initial[i]._pk);
                  var _pk2 = this.$api._get_by_pk(values,this.ACCOUNTCONTROLSoptions.initial[i]._pk);
                  console.log('change_useraccountcontrol, values[i]='+JSON.stringify(values[i])+', PHASE 2, pk0='+JSON.stringify(_pk0)+', pk1='+JSON.stringify(_pk1)+', pk2='+JSON.stringify(_pk2))
                  if ( _pk0==null && _pk1==null && _pk2==null ) {
                     this.old_useraccountcontrols.push(this.ACCOUNTCONTROLSoptions.initial[i]);
                     this.boolUACChanged = true;
                  }
                  if ( _pk0!=null && _pk1==null && _pk2!=null ) {
                     this.$api._remove_by_pk( this.old_useraccountcontrols,_pk0._pk);
                     this.boolUACChanged = true;
                  }
               } 
            }
            console.log('change_useraccountcontrol, PHASE2, old_useraccountcontrols='+JSON.stringify(this.old_useraccountcontrols))
            console.log('change_useraccountcontrol, PHASE2, new_useraccountcontrols='+JSON.stringify(this.new_useraccountcontrols))

            for ( var i=0;i<this.new_useraccountcontrols.length;i++ ) {
               // Take care : some row could be NULL (corresponding to unknown AD groups)
               if ( this.new_useraccountcontrols[i]!=null ) {
                  var _pk0 = null;
                  var _pk1 = this.$api._get_by_pk(this.ACCOUNTCONTROLSoptions.initial,this.new_useraccountcontrols[i]._pk);
                  var _pk2 = this.$api._get_by_pk(values,this.new_useraccountcontrols[i]._pk);
                  console.log('change_useraccountcontrol, values[i]='+JSON.stringify(values[i])+', PHASE 3, pk0='+JSON.stringify(_pk0)+', pk1='+JSON.stringify(_pk1)+', pk2='+JSON.stringify(_pk2))
                  if ( _pk1==null && _pk2==null ) {
                     this.$api._remove_by_pk( this.new_useraccountcontrols,this.new_useraccountcontrols[i]._pk);
                     this.boolUACChanged = true;
                  }
               } 
            }
            console.log('change_useraccountcontrol, PHASE3, old_useraccountcontrols='+JSON.stringify(this.old_useraccountcontrols))
            console.log('change_useraccountcontrol, PHASE3, new_useraccountcontrols='+JSON.stringify(this.new_useraccountcontrols))

            this.recheck_elements();

         }
         
      },

      recheck_elements() {
         this.level.row.lde_changes_groups = { insert: this.new_groups, delete: this.old_groups }
         this.level.row.lde_changes_useraccountcontrols = { insert: this.new_useraccountcontrols, delete: this.old_useraccountcontrols }
      },

      remove_group(item) {
         console.log('remove_group, item='+JSON.stringify(item));
         if ( item._pk ) {
            /*
             * We remove it from 'new_groups', if it is in this array
             */
            this.$api._remove_by_pk(this.new_groups,item._pk);
            /*
             * We retrieve the _pk of the user to add in 'old_groups' array, and add it from 'old_groups'
             * But there is no need to do that if we are in creation mode
             */
            if ( this.level.dialogValues.form_create!=true ) {
               this.$api._remove_by_pk(this.old_groups,item._pk);
               this.old_groups.push(JSON.parse(JSON.stringify(item)));
            }
            // We remove it from the selection, but it could have deen done in parent 'remove' function
            this.$api._remove_by_pk(this.GRPoptions.selected,item._pk);
            this.boolGroupsChanged = true;
            this.recheck_elements();
         }
      },

      /*
       * This function is just called to detect :
       *  - group(s) added to selection and to add them to 'this.new_groups'
       *  - group(s) deselected, i-e deleted, and to add them to 'this.old_groups'
       */
      async change_group(values,item=null) {
         console.log('change_group, values='+JSON.stringify(values))
         console.log('change_group, initial='+JSON.stringify(this.GRPoptions.initial))

         if ( this.GRPoptions.initial ) {

            for ( var i=0;i<values.length;i++ ) {
               // Take care : some row could be NULL (corresponding to unknown AD groups)
               if ( values[i]!=null ) {
                  var _pk0 = this.$api._get_by_pk(this.old_groups,values[i]._pk);
                  var _pk1 = this.$api._get_by_pk(this.new_groups,values[i]._pk);
                  var _pk2 = this.$api._get_by_pk(this.GRPoptions.initial,values[i]._pk);
                  console.log('change_group, values[i]='+JSON.stringify(values[i])+', PHASE 1, pk0='+JSON.stringify(_pk0)+', pk1='+JSON.stringify(_pk1)+', pk2='+JSON.stringify(_pk2))
                  if ( _pk0==null && _pk1==null && _pk2==null ) {
                     this.new_groups.push(values[i]);
                     this.boolGroupsChanged = true;
                  }
                  if ( _pk0!=null && _pk1==null && _pk2!=null ) {
                     this.$api._remove_by_pk( this.old_groups,_pk0._pk);
                     this.boolGroupsChanged = true;
                  }
               } 
            }
            console.log('change_group, PHASE1, old_groups='+JSON.stringify(this.old_groups))
            console.log('change_group, PHASE1, new_groups='+JSON.stringify(this.new_groups))

            for ( var i=0;i<this.GRPoptions.initial.length;i++ ) {
               // Take care : some row could be NULL (corresponding to unknown AD groups)
               if ( this.GRPoptions.initial[i]!=null ) {
                  var _pk0 = this.$api._get_by_pk(this.new_groups,this.GRPoptions.initial[i]._pk);
                  var _pk1 = this.$api._get_by_pk(this.old_groups,this.GRPoptions.initial[i]._pk);
                  var _pk2 = this.$api._get_by_pk(values,this.GRPoptions.initial[i]._pk);
                  console.log('change_group, values[i]='+JSON.stringify(values[i])+', PHASE 2, pk0='+JSON.stringify(_pk0)+', pk1='+JSON.stringify(_pk1)+', pk2='+JSON.stringify(_pk2))
                  if ( _pk0==null && _pk1==null && _pk2==null ) {
                     this.old_groups.push(this.GRPoptions.initial[i]);
                     this.boolGroupsChanged = true;
                  }
                  if ( _pk0!=null && _pk1==null && _pk2!=null ) {
                     this.$api._remove_by_pk( this.old_groups,_pk0._pk);
                     this.boolGroupsChanged = true;
                  }
               } 
            }
            console.log('change_group, PHASE2, old_groups='+JSON.stringify(this.old_groups))
            console.log('change_group, PHASE2, new_groups='+JSON.stringify(this.new_groups))

            for ( var i=0;i<this.new_groups.length;i++ ) {
               // Take care : some row could be NULL (corresponding to unknown AD groups)
               if ( this.new_groups[i]!=null ) {
                  var _pk0 = null;
                  var _pk1 = this.$api._get_by_pk(this.GRPoptions.initial,this.new_groups[i]._pk);
                  var _pk2 = this.$api._get_by_pk(values,this.new_groups[i]._pk);
                  console.log('change_group, values[i]='+JSON.stringify(values[i])+', PHASE 3, pk0='+JSON.stringify(_pk0)+', pk1='+JSON.stringify(_pk1)+', pk2='+JSON.stringify(_pk2))
                  if ( _pk1==null && _pk2==null ) {
                     this.$api._remove_by_pk( this.new_groups,this.new_groups[i]._pk);
                     this.boolGroupsChanged = true;
                  }
               } 
            }
            console.log('change_group, PHASE3, old_groups='+JSON.stringify(this.old_groups))
            console.log('change_group, PHASE3, new_groups='+JSON.stringify(this.new_groups))

            this.recheck_elements();

         }
         
      },

      async change(value,item=null) {
         if ( item==null ) {
            item = this.$api._get_by_pk(this.$refs.myLDTSelect.items,value);
         }
         this.bools.is_ou      = item.ldt_is_ou;
         this.bools.is_group   = item.ldt_is_group;
         this.bools.is_user    = item.ldt_is_user;
         this.bools.is_contact = item.ldt_is_contact;
         this.bools.is_root    = false;
         this.$emit('changeSelectLDT',value,item);
      },

      build_initial_accountcontrols() {
         var data = [];
         /*
          * We create an array of objects, one for each username, to be used by <ddoSelect>
          * BUT (BUT!) :
          * - there must be a property of _pk, for each object
          * - this _pk must start to 1. If equals to 0, row cannot be deleted
          */
         if ( this.row.useraccountcontrol!=null ) {
            for (var i=0;i<this.items_useraccountcontrols.length;i++) {
               let _checkedbit = this.row.useraccountcontrol & this.items_useraccountcontrols[i]._pk;
               if (  _checkedbit == this.items_useraccountcontrols[i]._pk ) {
                  data.push(this.items_useraccountcontrols[i]);
               }
            }
         }
         this.ACCOUNTCONTROLSoptions.initial = data;
         this.ACCOUNTCONTROLSoptions.selected = data;
      },

      async change_accountcontrols(values,item=null) {
      },

      check_skip_confirm(method,row) {
         console.log('check_skip_confirm, method='+method+', lengths='+this.new_useraccountcontrols.length+'/'+this.old_useraccountcontrols.length)
         var check = false;
         switch (method) {
            case 'create':
               check = true;
               break;
            case 'update':
               check = (this.new_groups.length==0 && this.old_groups.length==0 && this.new_useraccountcontrols.length==0 && this.old_useraccountcontrols.length==0 );
               break;
            case 'delete':
               check = false;
               break;
         }
         return check;
      },
   },
}
</script>